'use client';
// TODO: Fix React 19 compiler lint errors. See https://react.dev/learn/react-compiler
/* eslint-disable react-hooks/purity */
import { useEffect, useRef, useCallback } from 'react';

export default function useTimer(onUnload?: (time: number) => void) {
  const startedAtRef = useRef(Date.now());
  const onUnloadRef = useRef(onUnload);

  const getTime = useCallback(() => {
    return Date.now() - startedAtRef.current;
  }, []);

  useEffect(() => {
    onUnloadRef.current = onUnload;
  }, [onUnload]);

  useEffect(() => {
    function handleBeforeUnload() {
      if (onUnloadRef.current) {
        onUnloadRef.current(getTime());
      }
    }

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      handleBeforeUnload();
    };
  }, [getTime]);

  return getTime;
}
